export const EMAIL_REGEXP =
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])+/i;

export const required = (value, code = 'required') => {
  if (typeof value === 'string') {
    return value.trim() ? undefined : [{ code }];
  }
  return value ? undefined : [{ code }];
};

export const validateMinimumLength = (value = '', minimumLength, code = 'required') => {
  if (value.length >= minimumLength) {
    return undefined;
  }
  return [{ code }];
};

export const validColor = (value) =>
  /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/i.test(value)
    ? undefined
    : [
        {
          code: 'color_code',
          value,
        },
      ];
// eslint-disable-next-line no-restricted-globals
export const validNumber = (value) =>
  !isNaN(value)
    ? undefined
    : [
        {
          code: 'invalid_number',
          value,
        },
      ];
// eslint-disable-next-line no-restricted-globals
export const validPercent = (value) =>
  !isNaN(value) && value >= 0 && value <= 100
    ? undefined
    : [
        {
          code: 'invalid_percent',
          value,
        },
      ];

export const requiredArray = (values) =>
  Array.isArray(values) && values.length
    ? undefined
    : [
        {
          code: 'required_array',
        },
      ];

export const noForbiddenValueInArray = (values, forbidden, code) => {
  const forbiddenIndex = values.indexOf(forbidden);
  if (forbiddenIndex >= 0) {
    return values.map((val, index) =>
      index === forbiddenIndex
        ? [
            {
              code,
            },
          ]
        : undefined
    );
  }
  return undefined;
};

export const noBlankValuesInArray = (array = [], code = 'required') =>
  array.map((val) =>
    !val
      ? [
          {
            code,
          },
        ]
      : undefined
  );

export const validInteger = (value, code = 'integer') =>
  Number.isInteger(Number(value))
    ? undefined
    : [
        {
          code,
        },
      ];

export const lessOrEqual = (value, max, code = 'less_than_or_equal') =>
  value > max
    ? [
        {
          value: max,
          code,
        },
      ]
    : undefined;

export const greaterThanOrEqual = (value, min, code = 'greater_than_or_equal') =>
  value <= min
    ? [
        {
          value: min,
          code,
        },
      ]
    : undefined;

export const greaterThan = (value, min, code = 'greater_than_or_equal') =>
  value < min
    ? [
        {
          value: min,
          code,
        },
      ]
    : undefined;

export const validEmail = (value) =>
  EMAIL_REGEXP.test(value)
    ? undefined
    : [
        {
          code: 'email',
        },
      ];

export const equalToPassword = (value, equalValue) =>
  value === equalValue
    ? undefined
    : [
        {
          code: 'equal_to_password',
        },
      ];

export const stringLongerThan = (string, min) =>
  string.length >= min
    ? undefined
    : [
        {
          code: 'string_longer_than',
          value: min,
        },
      ];

export const stringShorterThan = (string, max) =>
  string.length <= max
    ? undefined
    : [
        {
          code: 'string_shorter_than',
          value: max,
        },
      ];

export const validateWhitespaces = (value) =>
  /\s/i.test(value)
    ? [
        {
          code: 'invalid_characters',
          value,
        },
      ]
    : undefined;

export const validatePassword = (value) => {
  if (!value) {
    return undefined;
  }

  const errors = [];

  // Minimum 8 characters
  if (value.length < 8) {
    errors.push({ code: 'password_min_length' });
  }

  // At least one uppercase letter
  if (!/[A-Z]/.test(value)) {
    errors.push({ code: 'password_uppercase' });
  }

  // At least one lowercase letter
  if (!/[a-z]/.test(value)) {
    errors.push({ code: 'password_lowercase' });
  }

  if (!/[0-9]/.test(value)) {
    // At least one number
    errors.push({ code: 'password_number' });
  }

  // At least one special character
  if (!/[!@#$%^&*(),.?":{}|<>]/.test(value)) {
    errors.push({ code: 'password_special_char' });
  }

  // No whitespace
  if (/\s/.test(value)) {
    errors.push({ code: 'password_no_whitespace' });
  }

  return errors.length > 0 ? errors : undefined;
};

export default {
  required,
  validColor,
  validNumber,
  validPercent,
  validInteger,
  validEmail,
  requiredArray,
  noForbiddenValueInArray,
  noBlankValuesInArray,
  lessOrEqual,
  greaterThanOrEqual,
  greaterThan,
  stringLongerThan,
  validateWhitespaces,
  validatePassword,
};
